import { AppAlertHost } from "./AppAlertHost";
import { AlertReactBootstrap } from './_Templates/AlertReactBootstrap';
import { AlertSonnerHost, onNotifySonner } from './_Templates/AlertSonner';
import { AlertHotToastHost, onNotifyHotToast } from './_Templates/AlertHotToast';
import { AlertToastifyHost, onNotifyToastify } from './_Templates/AlertToastify';
import { AlertNotistackHost, onNotifyNotistack } from './_Templates/AlertNotistack';
import { AlertSweetAlertHost, onNotifySweetAlert } from './_Templates/AlertSweetAlert';
/*
    🔥 REGISTRO DE IMPLEMENTACIONES DE ALERT

    Hay DOS familias y no son intercambiables sin más:

    kind: 'inline'  -> componente declarativo. Se renderiza donde lo pongas.
    kind: 'toast'   -> función imperativa. Se dispara con notify() y flota.
                       Necesita su Host montado una sola vez.

    ⚠️ Las cinco de toast renderizan el MISMO ToastBody, así que se ven
       igual entre sí y respetan tus 8 variantes. Lo único que cambia es
       el motor: apilado, animación y auto-cierre.
*/

export const ALERT_TEMPLATES = [

    {
        id: 'reactBootstrap', label: 'React Bootstrap', kind: 'inline',
        component: AlertReactBootstrap, Host: null, notify: null,
    },

    {
        id: 'sonner', label: 'Sonner', kind: 'toast',
        component: null, Host: AlertSonnerHost, notify: onNotifySonner,
    },

    {
        id: 'hotToast', label: 'React Hot Toast', kind: 'toast',
        component: null, Host: AlertHotToastHost, notify: onNotifyHotToast,
    },

    {
        id: 'toastify', label: 'React Toastify', kind: 'toast',
        component: null, Host: AlertToastifyHost, notify: onNotifyToastify,
    },

    {
        id: 'notistack', label: 'Notistack', kind: 'toast',
        component: null, Host: AlertNotistackHost, notify: onNotifyNotistack,
    },

    {
        id: 'sweetAlert', label: 'SweetAlert2', kind: 'toast',
        component: null, Host: AlertSweetAlertHost, notify: onNotifySweetAlert,
    },

];

export const ALERT_TEMPLATE_IDS = ALERT_TEMPLATES.map((item) => item.id);

const FALLBACK_TEMPLATE = ALERT_TEMPLATES[0];

export const onResolveAlertTemplate = (id) => (
    ALERT_TEMPLATES.find((item) => item.id === id) ?? FALLBACK_TEMPLATE
);
